<template>
  <div class="container">
    <template v-if="current_step === 4">
      <div v-if="all_keys.length === done_keys" class="all-info">
        <div class="left">
          <div class="top">
            <div
              v-for="(elem, index) in all_keys"
              class="row"
              :key="'icon' + index"
              @click="$emit('navigate', [elem, true])"
            >
              <div class="row-left">
                <img
                  :src="
                    require('../../assets/images/konstrukcija/desktop_pozicije/' +
                      ('' + elem).padStart(2, '0') +
                      '_icon.svg')
                  "
                  alt=""
                />
              </div>
              <div class="row-middle">
                {{ main_data.pos_position.select[elem] }}
              </div>
              <div class="row-right">
                <img
                  v-if="main_data.pos_status.value[elem].potvrda"
                  src="../../assets/images/desktop/stikla_bela.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div :class="{ bottom: true, active: additional_data }">
            <div class="row">
              <div class="row-middle green">{{ main_data.app_more_parameters.title }}</div>
              <div class="row-right">
                <vue-checkbox :value="additional_data" @input="set_additional_data" class="vue-checkbox">
                </vue-checkbox>
              </div>
            </div>
            <div
              class="row"
              :class="{ dead: !additional_data }"
              @click="additional_data ? $emit('navigate', [10, false]) : null"
            >
              <div class="row-left bottom">
                <img
                  v-if="additional_data"
                  src="../../assets/images/konstrukcija/desktop_pozicije/10_icon.svg"
                  alt=""
                />
                <img v-else src="../../assets/images/konstrukcija/desktop_pozicije/10_icon_dimmed.svg" alt="" />
              </div>
              <div class="row-middle">
                {{ main_data.pos_position.select[10] }}
              </div>
              <div class="row-right">
                <img
                  v-if="main_data.pos_status.value[10].potvrda"
                  src="../../assets/images/desktop/stikla_bela.svg"
                  alt=""
                />
              </div>
            </div>
            <div
              v-if="main_data.pos_status.value[13]"
              class="row"
              :class="{ dead: !additional_data }"
              @click="additional_data ? $emit('navigate', [13, false]) : null"
            >
              <div class="row-left bottom">
                <img
                  v-if="additional_data"
                  src="../../assets/images/konstrukcija/desktop_pozicije/13_icon.svg"
                  alt=""
                />
                <img v-else src="../../assets/images/konstrukcija/desktop_pozicije/13_icon_dimmed.svg" alt="" />
              </div>
              <div class="row-middle">
                {{ main_data.pos_position.select[13] }}
              </div>
              <div class="row-right">
                <img
                  v-if="main_data.pos_status.value[13].potvrda"
                  src="../../assets/images/desktop/stikla_bela.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="outer-circle">
            <div class="inner-circle">
              <img src="../../assets/images/desktop/stikla_desktop.svg" alt="" />
            </div>
          </div>
          <div class="title">{{ main_data.pos_info_title.title }}</div>
          <div class="spacer"></div>
          <div class="subtitle">{{ main_data.pos_info_subtitle_1.title }}</div>
          <div class="spacer"></div>
          <div class="subtitle second">{{ main_data.pos_info_subtitle_2.title }}</div>
          <div class="button" @click="$emit('confirm-step', current_step)">{{ main_data.app_next.title }}</div>
        </div>
      </div>
      <div v-else-if="done_keys > 0" class="some-info">
        <div class="left">
          <img src="../../assets/images/desktop/plava_cvrcka.svg" alt="" />
        </div>
        <div class="right">{{ main_data.pos_info_click.title }}</div>
      </div>
      <div v-else class="none-info">
        <img src="../../assets/images/desktop/exclamation.svg" alt="" />
        <div class="top">{{ main_data.pos_info_1.title }}</div>
        <div class="bottom">{{ main_data.pos_info_2.title }}</div>
      </div>
    </template>
    <div v-else class="none-info second">
      <img src="../../assets/images/desktop/exclamation.svg" alt="" />
      <div class="top">{{ main_data.pos_intervention_start.title }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .none-info {
    width: 55rem;
    height: 39rem;
    border-radius: 4.8rem;
    background-color: $main_header_middle;
    font-size: 2.1rem;
    line-height: 1.24;
    text-align: center;
    color: $text-white;
    position: relative;
    padding: 0 6.3rem 0 6.3rem;

    &.second {
      height: 24rem;
      font-size: 2.4rem;
    }

    .top {
      margin-top: 10rem;
    }

    .bottom {
      margin-top: 3rem;
    }

    img {
      position: absolute;
      max-width: 11.5rem;
      max-height: 11.5rem;
      width: 11.5rem;
      height: 11.5rem;
      left: 50%;
      top: 0;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .some-info {
    font-size: 2.4rem;
    line-height: 1.08;
    text-align: center;
    color: $text_white;
    align-items: center;
    display: flex;

    .left {
      width: 4rem;
      height: 4rem;
      margin-right: 1.5rem;

      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }

  .all-info {
    width: 90.6rem;
    height: 71rem;
    display: flex;
    background-color: $main_header_middle;
    border-radius: 5.3rem;

    .left {
      width: 49rem;
      padding: 4.2rem 3.9rem 3.4rem 4.2rem;
      display: flex;
      flex-direction: column;
      color: $text_white;

      .top {
        flex: 1 0 auto;
      }

      .bottom {
        flex: 0 0 auto;
        color: $desktop_button_inactive;

        &.active {
          color: $text_white;
        }
      }

      .row {
        height: 5rem;
        max-height: 5rem;
        display: flex;
        align-items: center;
        font-size: 2.1rem;
        line-height: 0.76;

        &:not(.dead) {
          cursor: pointer;
        }

        &:not(:last-child) {
          margin-bottom: 3rem;
        }

        .row-left {
          // width: 9rem;
          // max-width: 9rem;
          min-width: 9rem;

          &.bottom {
            margin-left: 1rem;
          }

          img {
            max-width: 7rem;
            max-height: 6rem;
            height: 6rem;
          }
        }

        .row-middle {
          flex-grow: 1;

          &.green {
            color: $desktop_green;
          }
        }

        .row-right {
          width: 3rem;
          max-width: 3rem;
          margin-left: 1rem;

          img {
            width: 100%;
            max-width: 100%;
          }

          .vue-checkbox {
            height: 3rem;
            width: 3rem;
            border: 2px solid $desktop_green;
            background-color: $desktop_button_inactive;
            margin-left: 1rem;
            border: none;
            color: $desktop_green;
          }
        }
      }
    }

    .right {
      margin: 4.2rem 0 3.4rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      border-left: 1px solid $main_header_light;
      flex-grow: 1;

      .outer-circle {
        width: 16rem;
        height: 16rem;
        margin: 3.3rem auto 0 auto;
        background-color: rgba(36, 196, 108, 0.51);
        border-radius: 50%;
        position: relative;

        .inner-circle {
          position: absolute;
          width: 11.8rem;
          height: 11.8rem;
          top: calc(50% - 5.9rem);
          left: calc(50% - 5.9rem);
          background-color: $desktop-green;
          border-radius: 50%;
          z-index: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 50%;
            max-width: 50%;
          }
        }
      }

      .image {
        margin-top: 3.3rem;
        height: 16rem;
        width: 16rem;

        img {
          width: 100%;
          height: 100%;
          max-width: 100%;
        }
      }

      .title {
        margin-top: 3.5rem;
        width: 25rem;
        font-size: 2.4rem;
        line-height: 1.25;
        color: $text_white;
      }

      .subtitle {
        width: 31.4rem;
        font-size: 1.8rem;
        line-height: 1.17;
        color: $main_header_light;
      }

      .spacer {
        flex-grow: 1;
      }

      .button {
        margin-top: 3.2rem;
        width: 35rem;
        height: 7rem;
        border-radius: 3.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2.4rem;
        line-height: 1.17;
        color: $text_white;
        background-color: $desktop_green;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import checkbox from "../../components/checkbox.vue";

export default {
  props: ["main_data", "current_step"],
  components: {
    "vue-checkbox": checkbox,
  },
  data: function () {
    return {
      additional_data: false,
    };
  },

  computed: {
    all_keys: function () {
      return Object.keys(this.main_data.pos_status.value).filter((elem) => elem != 10 && elem != 13 && elem != 60);
    },
    done_keys: function () {
      return this.all_keys.filter((elem) => this.main_data.pos_status.value[elem].potvrda).length;
    },
    door_window_selected: function () {
      return this.main_data.pos_status.value[10].potvrda || this.main_data.pos_status.value[13].potvrda;
    },
  },
  methods: {
    set_additional_data: function () {
      if (this.additional_data) {
        this.$emit("set-status-data", { value: 10, potvrda: false });
        this.$emit("set-status-data", { value: 13, potvrda: false });
      }
      this.additional_data = !this.additional_data;
    },
  },
  mounted: function () {
    if (this.door_window_selected) {
      this.additional_data = true;
    }
  },
};
</script>
